import { track } from '@bigo/logger';
import { useAppStore } from '@/store/app';
import { checkIsMobile, checkIsPad } from '@/libs/utils';

const env = import.meta.env.VITE_BUILD_ENV;

// moduleId用来区分模块

export default function useTrack(moduleId = '', actId = 66965) {
  const isMobileSys = checkIsMobile() || checkIsPad();
  const appStore = useAppStore();
  const wrapExtra = (content: Record<string, any> = {}) => {
    return {
      ...content,
      page: isMobileSys ? 2 : 1,
      role: appStore.agentRole,
      name: appStore.loginUser?.username,
    };
  };

  const report = (
    action: string | number,
    // eslint-disable-next-line default-param-last
    content: Record<string, any> | string = '',
    extra?: Record<string, any>,
  ) => {
    if (['test', 'gray'].includes(env)) {
      console.log(action, content, extra);
    }

    const _content = typeof content === 'string' ? content : JSON.stringify(content);

    track({
      act_id: actId,
      log_event: moduleId as string,
      log_action: `${action}`,
      log_content: _content,
      extra: wrapExtra(extra),
    });
  };

  return {
    report,
  };
}
